//@ts-nocheck
import { Box, HStack, Select, Stack, Text, useToast } from "@chakra-ui/react";
import { isEmpty } from "lodash";
import { observer } from "mobx-react-lite";
import Pluralize from "pluralize";
import React from "react";
import BookingLists from "../components/BookingList";
import JobActionsModal from "../components/JobActionsModal";
import { useOverlayDisclosure } from "../components/OverlayRouter";
import { ITutorJobList } from "../stores";
import { filterOptions } from "../stores/jobs/utils/filterBookings";
import { scrollToTop } from "../utils/functions";

type Props = {
  bookings: Array<any>;
  tutorInfo: any;
  store: ITutorJobList;
  host: string;
  agent: any;
  displayFilter?: boolean;
  // onNavigate: (slug) => void
};

const JobListPage = observer(
  ({
    bookings = [],
    tutorInfo = {},
    store,
    host = "",
    agent,
    displayFilter,
  }: // onNavigate
  Props) => {
    const { isOpen, onOpen, onClose } = useOverlayDisclosure("/modal");
    const [actionType, setActionType] = React.useState("");
    const [weeklySchedule, setWeeklySchedule] = React.useState({});
    const bookingData = store.currentRequest;
    const [error, setError] = React.useState(false);
    const toast = useToast();

    const handleOpenModal = (action: string, slug: string) => {
      store.setCurrentRequest(slug);
      if (store.currentRequest) {
        setActionType(action);
        onOpen();
      }
    };

    const handleResponse = (response: any, closeModal = true) => {
      return store
        .updateJobStatus(response, actionType)
        .then(() => {
          if (closeModal) {
            onClose();
          }
          scrollToTop();
          toast({
            position: "top",
            title: "Request updated",
            description: "Thank you for responding.",
            status: "success",
            duration: 9000,
            isClosable: true,
          });
        })
        .catch((error) => {
          setError(true);
        });
    };
    return (
      <Stack spacing={5}>
        <Text mb={4} fontWeight="bold" fontSize={["3xl", "4xl"]}>
          Your lesson requests
        </Text>

        <Stack spacing={4}>
          {displayFilter ? (
            <HStack width="100%" justifyContent="space-between">
              <Box>
                <Select
                  zIndex={1}
                  onChange={(e) => store.updateBookingFilter(e.target.value)}
                  variant="outline"
                  borderColor="neutral.600"
                >
                  {filterOptions.map(
                    (option: { label: string; value: string }) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ),
                  )}
                </Select>
              </Box>
              <Text whiteSpace="nowrap">
                {Pluralize("request", bookings.length, true)}
              </Text>
            </HStack>
          ) : null}

          <BookingLists
            bookings={bookings}
            tutorInfo={tutorInfo}
            asSummary={displayFilter}
            onSetSchedule={setWeeklySchedule}
            onOpenModal={handleOpenModal}
            onNavigate={handleOpenModal as any}
            agent={agent}
            host={host}
            // onNavigate={onNavigate}
          />
        </Stack>

        {!isEmpty(bookingData) && (
          <JobActionsModal
            store={bookingData}
            booking={bookingData.jobInfo}
            action={actionType}
            isSubmitting={bookingData.serverInfo.loading}
            weeklySchedule={weeklySchedule}
            tutorInfo={tutorInfo}
            isOpen={isOpen}
            onClose={onClose}
            error={error}
            onRespond={handleResponse}
          />
        )}
      </Stack>
    );
  },
);

export default JobListPage;
